import { useQuery } from '@apollo/client';

import type { UserJobApplicationCv } from '@xing-com/crate-common-graphql-types';
import { GetUserRecentCvsDocument } from '@xing-com/crate-jobs-graphql';

import { getSortedCvs } from './util';

type UseGetUserRecentCvsReturnValue = {
  isGetUserRecentCvsError: boolean;
  isGetUserRecentCvsLoading: boolean;
  userRecentCvs: UserJobApplicationCv[];
};

export const useGetUserRecentCvs = (
  isLoggedIn: boolean
): UseGetUserRecentCvsReturnValue => {
  const { data, error, loading } = useQuery(GetUserRecentCvsDocument, {
    skip: !isLoggedIn,
    fetchPolicy: 'network-only',
  });

  return {
    isGetUserRecentCvsError: !!error || !data?.viewer?.userRecentCvs,
    isGetUserRecentCvsLoading: loading,
    userRecentCvs: getSortedCvs(data?.viewer?.userRecentCvs),
  };
};
